import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../api';

export interface Users {
    userId: string;
    firstName: string;
    lastName: string;
    emailAddress: string;
}

export const shareQueryUsers = createAsyncThunk<Users>('sharequery/users',async() => {
    let response = await axiosInstance.get(`/rest/sharequery/users`);
        return response.data;
    }
);

export const sharedUsersForGroupId = createAsyncThunk<Users, String>('sharequery/users/groupId',async(groupId) => {
    let response = await axiosInstance.get(`/rest/sharequery/users/${groupId}`);
        return response.data;
    }
);

export const shareQuerySave = createAsyncThunk<string, {groupId:string, usersList:any}>('sharequery/save', async({groupId, usersList}) => {
    let response = await axiosInstance.post(`/rest/sharequery/save/${groupId}`, usersList);
        return response.data;
    }
);

const initialState: any = {
    users: [],
    loading: false,
    error: null
};

const shareSlice = createSlice({
    name: 'share',
    initialState,
    reducers: {
        setSelectedGroupId: (state, action) => {
            state.groupId = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(shareQueryUsers.pending, (state) => {
                state.loading = true;
            })
            .addCase(shareQueryUsers.fulfilled, (state, action) => {
                state.loading = false;
                state.users = action.payload;
            })
            .addCase(shareQueryUsers.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || null; 
            })
            .addCase(sharedUsersForGroupId.pending, (state) => {
                state.loading = true;
            })
            .addCase(sharedUsersForGroupId.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(sharedUsersForGroupId.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || null; 
            });
    },
});

export const { setSelectedGroupId } = shareSlice.actions;
export default shareSlice.reducer;
